import { useState, type FormEvent } from 'react';
import { strings } from '../strings';
import { Icon } from './Icon';

export function SearchBox({ initial = '', onSearch }: { initial?: string; onSearch: (q: string) => void }) {
  const [value, setValue] = useState(initial);
  const submit = (e: FormEvent) => {
    e.preventDefault();
    onSearch(value);
  };
  return (
    <form role="search" onSubmit={submit} className="flex flex-col gap-2">
      <label htmlFor="kb-search" className="font-bold">
        {strings.search.label}
      </label>
      <div className="flex flex-wrap gap-3">
        <input
          id="kb-search"
          type="search"
          className="field min-w-0 flex-1"
          placeholder={strings.search.placeholder}
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
        <button type="submit" className="btn-primary">
          <Icon name="search" />
          {strings.search.submit}
        </button>
      </div>
    </form>
  );
}
